export const timeStringToFloat = (timeString) => {
  const [hours, minutes] = timeString.split(":").map(Number)
  const floatValue = hours + minutes / 60
  const roundedValue = Math.round(floatValue * 10000) / 10000

  return roundedValue
}

export const floatToTimeString = (floatValue) => {
  const hours = Math.floor(floatValue)
  const minutes = Math.round((floatValue - hours) * 60)
  const timeString = `${hours}:${minutes.toString().padStart(2, "0")}`

  return timeString
}
